import { actions, types } from './requests'
export const GETFROMIDFILTERING_TYPES = {
    ...types('GETFROMIDFILTERING'),
}
export const GETFROMIDFILTERING_ACTIONS = {
    ...actions('GETFROMIDFILTERING'),
}
